<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول سوالات سمینار</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                
                                &nbsp;

                                <a-button @click="isHidden = !isHidden"  class="btn-outline-blue" icon="plus">
                                    افزودن سوال
                                </a-button>
                                &nbsp;
                                <a-button  icon="paper-clip" type="link"  v-show="$root.hasPermission('/seminars/answers/')"
                                                :href="'/seminars/answers/' + $route.params.id"> پاسخ های نظرسنجی</a-button>
                                           
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                        <form @submit.prevent="addData($event)">
                        <div class="row" >
                                
                                 <div class="col-md-10 ">
                                <label class="sr-only" for="inline-form-input-name">
                                    عنوان سوال</label>
                                <input v-model="description" name="description" class="mb-2 mr-sm-2 mb-sm-0 form-control" />
                                <input type="hidden" name="seminar_id" :value="$route.params.id"  class="mb-2 mr-sm-2 mb-sm-0 form-control" />
                                </div>
                        <div class="col-md-1 my-4 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                        </div>
                        
                        </form>
                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">عنوان</th>
                                        <th scope="col"> پاسخ ها</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>


                                            <b-badge variant="light" class="text-dark">{{ row . description }}</b-badge>
                                        </td>

                                        <td>
                                            <a-tag v-for="val in row.answers" closable
                                                @close="deleteRow(`questions/delete/${val.id}`)">
                                                {{ val . description }}
                                            </a-tag>
                                            <a-input class="d-none" :id="'input' + row.id" type="text"
                                                size="small" style="width:200px;" 
                                                @keyup.enter="handleInputConfirm(row.id)" />
                                            <a-tag :id="'button' + row.id" @click="showInput(row.id)"
                                                style="background: #fff; borderStyle: dashed;">
                                                <a-icon type="plus" /> پاسخ جدید
                                            </a-tag>
                                        </td>
                             
                                        <td>

                                           
                                            <a-button class="btn-outline-danger" shape="square" icon="delete"
                                                @click="deleteRow(`questions/delete/${row.id}`)"></a-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: [],
                visible: false,
description:'',
                parents: [],
                cats: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                inputVisible: false,
                inputValue: [],
            };
        },
        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/questions/${this.$route.params.id}?page=${this.currentPage}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },


            deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
           
            showInput(id) {
                document.getElementById('input' + id).classList.toggle("d-none");
                document.getElementById('button' + id).classList.toggle("d-none");
            },
            handleInputConfirm(id) {
              let _this=this;
                const inputValue = document.getElementById('input' + id).value;
                let data = new FormData();
                data.append("description", inputValue);
                data.append("parent_id", id);
                data.append("seminar_id", this.$route.params.id);
                axios
                    .post("/questions/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("مقدار با موفقیت ذخیره شد");
                        _this.getData();
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            addData(event) {
              let _this=this;
                let data = new FormData(event.target);
               
                axios
                    .post("/questions/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success(" با موفقیت ذخیره شد");
                        _this.description='';
                        _this.getData();
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
